export default __webpack_public_path__ + "img/eupykZmH.bd15dd22.svg";